import { render, staticRenderFns } from "./TblUsersDetail.vue?vue&type=template&id=d50c8d8c&scoped=true&"
import script from "./TblUsersDetail.vue?vue&type=script&lang=js&"
export * from "./TblUsersDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblUsersDetail.vue?vue&type=style&index=0&id=d50c8d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50c8d8c",
  null
  
)

export default component.exports